import clsx from 'clsx';

interface AllSetStatusProps {
  providerDisplayName?: string;
  className?: string;
}

export function AllSetStatus({ providerDisplayName, className }: AllSetStatusProps) {
  const getTimeOfDay = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'morning';
    if (hour < 17) return 'afternoon';
    return 'evening';
  };

  const timeOfDay = getTimeOfDay();

  return (
    <div
      // TODO: mute this a little? use brand green 0 and 1?
      className={clsx(
        'tw:rounded-lg tw:p-4 tw:bg-gradient-to-r tw:from-teal-600 tw:to-cyan-600 tw:text-white tw:flex tw:items-center tw:justify-between tw:shadow-lg',
        className
      )}
    >
      <div className="tw:flex-1">
        <h2 className="tw:text-xl tw:font-semibold tw:mb-1">
          Good {timeOfDay} {providerDisplayName}
        </h2>
        <p className="tw:text-teal-100 tw:text-sm">
          You&apos;re all caught up! No urgent actions needed.
        </p>
      </div>
      <div className="tw:ml-4 tw:flex-shrink-0">
        <div className="tw:w-12 tw:h-12 tw:bg-teal-500 tw:rounded-full tw:flex tw:items-center tw:justify-center">
          <svg
            className="tw:w-6 tw:h-6 tw:text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default AllSetStatus;
